import { render, staticRenderFns } from "./StallionStocks.vue?vue&type=template&id=6caa4be7&"
import script from "./StallionStocks.vue?vue&type=script&lang=js&"
export * from "./StallionStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports